import { GetStaticPaths, GetStaticProps } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import { Translate, useTranslate } from '~/i18n';
import { publicUrl } from '~/utils/publicUrl';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import Container from '~/components/common/container';

/**
 * This page contains voucher terms and conditions
 */
const VoucherTerms = () => {
   const { dir } = useTranslate();

   return (
      <Container className="mb-10 mt-16 tablet:mt-4">
         <style jsx global>
            {`
               body #__next main {
                  background: linear-gradient(
                     340.03deg,
                     rgba(250, 172, 168, 0.18) 0%,
                     rgba(221, 214, 243, 0.3) 99.97%
                  );
               }
            `}
         </style>
         <h1 className="text-3xl font-black mb-14">
            <Translate id="vouchers:terms and conditions" />
         </h1>
         <ul className="mb-16 space-y-6 list-disc ltr:pl-4 rtl:pr-4">
            <li>
               <Translate id="vouchers:can use if sufficient" />
            </li>
            <li>
               <Translate id="vouchers:can't change gift card to money" />
            </li>
            <li>
               <Translate id="vouchers:not refundable" />
            </li>
            <li>
               <Translate id="vouchers:one year redeem" />
            </li>
            <li>
               <Translate id="vouchers:not transferable" />
            </li>
         </ul>
         <div>
            <h2 className="mb-4 text-xl font-black">
               <Translate id="common:need help" />
            </h2>
            <a
               target="_blank"
               rel="noreferrer noopener"
               href="https://wa.me/966115207040/?text="
               className="flex w-full p-3 bg-white border rounded-3xl border-gray-50 tablet:w-1/2">
               <div className="flex-grow">
                  <span className="flex items-center">
                     <img
                        width="24px"
                        height="24px"
                        src={publicUrl('images/common/whatsapp.png')}
                        alt="halayalla whatsapp"
                        className="ltr:mr-1 rtl:ml-1"
                     />
                     <Translate id="common:message halayalla support" />
                  </span>
               </div>
               {dir === 'ltr' ? <AngelRightIcon /> : <AngelLeftIcon />}
            </a>
         </div>
      </Container>
   );
};

export default VoucherTerms;

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};
